import { ComponentRenderer } from 'app/src/features/UserInfo/components/ComponentRenderer'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { PageWidget } from 'app/src/shared/components'
import { useComponentRenderer, usePageTitle, useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function UserInfo(): ReactElement {
  const context = useWebAppContext()
  const { getPage } = useComponentRenderer()
  const userInfoPageConfig = pageconfigurationsApi.usePageRequestGet({
    pathParams: { id: 'userinfopage', templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })
  const { t } = useTranslation('home')

  // Imposta il titolo della pagina
  usePageTitle(t('AppBar.UserInfo'))

  useEffect(() => {
    context.update({ breadCrumbItems: [] })

    //evita loop su contesto
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <PageWidget containerClassNamesOverrides='mb-1'>
        <h1 className='text-3xl font-bold'>{t('AppBar.UserInfo')}</h1>
      </PageWidget>
      {ComponentRenderer(getPage(userInfoPageConfig?.data))}
    </>
  )
}
